import React from 'react';
import styles from './Card.module.css';

/**
 * Card — primitive de carte bento.
 * - `span` (3/4/5/6/7/8/12) : largeur en colonnes
 * - `rowSpan` (2)            : hauteur sur 2 lignes
 */
export default function Card({
  span = 6,
  rowSpan,
  className = '',
  children,
  id,
  ...rest
}) {
  const classes = [
    styles.card,
    styles[`span${span}`],
    rowSpan === 2 ? styles.row2 : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={classes} id={id} {...rest}>
      {children}
    </section>
  );
}
